import { useEffect, useState } from 'react';

import { IconButton } from '@components/iconButton';
import { Search as SearchIcon } from '@assets/svgs';

import { SearchField } from '@components/search/SearchField';
import { useTableStore } from '@components/table/StoreTable/TableWithStore';

interface ITextInput {
  value: string;
  isUserTyping: boolean;
}

interface SearchBarProps {
  onFilterChange: (key: string, value: any) => void;
  defaultValue?: string;
  alwaysOpen?: boolean;
  size?: 'small' | 'medium';
  overrideValue?: string;
}

export const SearchBar = ({ defaultValue, alwaysOpen, size, onFilterChange }: SearchBarProps) => {
  const { appliedFilters = {} } = useTableStore((state) => ({ appliedFilters: state.appliedFilters }));
  const [textInput, setTextInput] = useState<ITextInput>({
    value: appliedFilters?.searchText ?? defaultValue ?? '',
    isUserTyping: false,
  });
  const [showSearchBar, setShowSearchBar] = useState<boolean>(!!textInput.value);

  const handleOnChangeSearchbar = (newValue: string) => {
    if (newValue === '') {
      setTextInput({ value: '', isUserTyping: true });
    } else {
      setTextInput({ value: newValue, isUserTyping: true });
    }

    onFilterChange('searchText', newValue);
  };

  const handleOnCleanSearchbarText = () => {
    setTextInput({ value: '', isUserTyping: false });
    setShowSearchBar(false);
  };

  const handleShowSearchbar = () => {
    setShowSearchBar(true);
    setTextInput({ value: textInput.value, isUserTyping: true });
  };

  useEffect(() => {
    if (appliedFilters?.searchText !== undefined && appliedFilters?.searchText !== '') {
      setShowSearchBar(true);
      setTextInput({ value: appliedFilters?.searchText, isUserTyping: false });
    }
    if (defaultValue !== undefined && defaultValue !== '') {
      setTextInput({ value: defaultValue, isUserTyping: false });
      setShowSearchBar(true);
    }

    if (!textInput.isUserTyping && defaultValue === undefined && appliedFilters?.searchText === undefined) {
      setShowSearchBar(false);
      setTextInput({ value: '', isUserTyping: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appliedFilters?.searchText, defaultValue]);

  if (showSearchBar || alwaysOpen) {
    return (
      <SearchField
        autofocus={textInput.isUserTyping}
        overrideValue={textInput.value}
        onChange={handleOnChangeSearchbar}
        onPressEndIcon={handleOnCleanSearchbarText}
        sx={{ width: 240 }}
        size={size}
      />
    );
  }

  return (
    <IconButton
      id='search-button'
      variant='circular'
      onClick={handleShowSearchbar}
      aria-label='search-button'
      aria-valuetext='search-button'
    >
      <SearchIcon width='16px' height='15px' />
    </IconButton>
  );
};
